import { createTheme, Button, Input, SegmentedControl, Modal, Pagination, Avatar } from "@mantine/core";
import buttonClasses from "../customStyle/button/button.module.css";
import inputClasses from "../customStyle/input/input.module.css";
import tabClasses from "../customStyle/tab/tab.module.css";
import segmentedControlClasses from "../customStyle/input/segmentedControl.module.css";
import notificationClasses from "../customStyle/notification/notification.module.css";
// import containerClasses from "../customStyle/layout/container.module.css";
import chipClasses from "../customStyle/chip/chip.module.css";
import { Chip, Text, Title } from "@mantine/core";
import { Flex, Tabs, Container } from "@mantine/core";
import { Notification } from "@mantine/core";

// design tokens
import colors from "../designTokens/colors.js";
import colorsVariants from "../designTokens/colorsVariants.js";
import types from "../designTokens/type.js";
import other from "../designTokens/other.js";
import { rem as breakpointRem } from "../designTokens/breakpoints.js";

// Mantine expects each entry in theme.colors to be an array of shades.
// colors is already a clean object with color arrays
const colorsForMantine = colors;

export const theme = createTheme({
	colors: {
		...colorsForMantine,
		...colorsVariants,
	},
	primaryColor: "gray",
	primaryShade: { light: 5, dark: 8 },
	// fontFamily: "Pretendard Variable",
	fontFamily: "'SUIT Variable', sans-serif",
	...types,
	other: other,
	spacing: {
		// "xs": "0.625rem",
		// "sm": "0.75rem",
		// "md": "1rem",
		// "lg": "1.25rem",
		// "xl": "1.5rem",
		// "2xl": "2rem",

		"01": "0.125rem",
		"02": "0.25rem",
		//xs
		xs: "0.5rem",
		"03": "0.5rem",
		//sm
		sm: "0.75rem",
		"04": "0.75rem",
		//md
		md: "1rem",
		"05": "1rem",
		//lg
		lg: "1.5rem",
		"06": "1.5rem",
		//xl
		xl: "2rem",
		"07": "2rem",
		"08": "2.5rem",
		"09": "3rem",
		//2xl
		"2xl": "4rem",
		10: "4rem",
		11: "5rem",
		12: "6rem",
		13: "10rem",
		cxs: other.size.xs,
		csm: other.size.sm,
		cmd: other.size.md,
		clg: other.size.lg,
		cxl: other.size.xl,
	},
	// Canonical breakpoint scale (designTokens/breakpoints.js). Shared with the
	// MUI theme so both styling systems resolve identical breakpoints.
	breakpoints: {
		xs: breakpointRem.xs,
		sm: breakpointRem.sm,
		md: breakpointRem.md,
		lg: breakpointRem.lg,
		xl: breakpointRem.xl,
	},
	components: {
		Container: Container.extend({
			defaultProps: {
				size: "100%",
				p: 0,
			},
			styles: {},
			vars: (theme, props) => {
				if ((props.size = "xl")) {
					return {
						root: {
							"--container-size-xl": other.size.xl,
						},
					};
				}
				if ((props.size = "lg")) {
					return {
						root: {
							"--container-size-xl": other.size.lg,
						},
					};
				}
				if ((props.size = "md")) {
					return {
						root: {
							"--container-size-xl": other.size.md,
						},
					};
				}
				if ((props.size = "sm")) {
					return {
						root: {
							"--container-size-xl": other.size.sm,
						},
					};
				}
				if ((props.size = "xs")) {
					return {
						root: {
							"--container-size-xl": other.size.xs,
						},
					};
				}
			},
		}),
		Button: Button.extend({
			// Add Custom Variant
			classNames: buttonClasses,
		}),
		Input: Input.extend({
			// Add Underline Variants
			// classNames: inputClasses,
		}),
		TextInput: {
			// classNames: inputClasses,
			defaultProps: {
				inputWrapperOrder: ["label", "input", "description", "error"],
			},
		},
		Textarea: {
			classNames: inputClasses,
			defaultProps: {
				inputWrapperOrder: ["label", "input", "description", "error"],
			},
		},
		// SegmentedControl: SegmentedControl.extend({
		// 	classNames: segmentedControlClasses,
		// 	styles: {
		// 		root: {
		// 			backgroundColor: colors.gray[0],
		// 		},
		// 		control: {
		// 			// backgroundColor: colors.gray[1],
		// 		},
		// 		active: {
		// 			backgroundColor: colors.gray[9],
		// 		},
		// 	},
		// }),
		Chip: Chip.extend({
			classNames: chipClasses,
			styles: {
				root: {},
				label: {
					textTransform: "capitalize",
					fontWeight: 600,
				},
			},
		}),
		Text: Text.extend({
			defaultProps: {
				size: "lg",
				align: "left",
			},
			styles: {
				root: {
					wordBreak: "keep-all",
					whiteSpace: "pre-line",
				},
			},
		}),
		Title: Title.extend({
			defaultProps: {
				align: "left",
			},
			styles: {
				root: {
					wordBreak: "keep-all",
				},
			},
		}),
		Flex: Flex.extend({
			styles: {
				root: {
					justifyItems: "flex-start",
				},
			},
		}),
		Tabs: Tabs.extend({
			classNames: tabClasses,
			styles: {
				tab: {
					// padding: "24px 24px",
				},
				tabLabel: {
					// fontSize: types.fontSizes.xl,
					fontWeight: 700,
				},
			},
		}),
		List: {
			defaultProps: {
				size: "lg",
			},
			styles: {
				root: {
					'& ::marker': {
						marginRight: '0rem !important'
					}
				},
				itemIcon: {
					display: "grid",
					marginRight: "4px",
				},
			},
		},
		
		Notification: Notification.extend({
			classNames: notificationClasses,
		}),
		Modal: Modal.extend({
			defaultProps: {
				radius: "lg", // radius 증가 (lg = 1rem)
				overlayProps: {
					blur: 4, // backdrop에 blur 적용
				},
			},
			styles: {
				title: {
					fontSize: types.fontSizes["2xl"] || "1.75rem", // 타이틀 사이즈 크게
					fontWeight: 900,
				},
			},
		}),
		Avatar: Avatar.extend({
			defaultProps: {
				color: "dark",
				autoContrast: true,
			},
			styles: {
				root: {
					"--avatar-bg": "#000000",
					"--avatar-color": "#ffffff",
					"--avatar-bd": "1px solid #e9ecef",
				},
				placeholder: {
					backgroundColor: "#000000",
					color: "#ffffff",
				},
			},
		}),
	},
});
